// @flow
import axios from 'axios';
import appsUtil from '../utils/AppsUtil';
import DeviceDetectionUtil from '../utils/DeviceDetectionUtil';
import {getContentfulPath} from '../utils/contentfulDataPathUtil';
import {getAEMPath} from '../utils/aemPathUtil';
import RestApiUtil from '../utils/RestApiUtil';
import {FETCH_FFC_DATA, SET_ERROR_TYPE, FETCH_COMPANION_FFC_DATA, FETCH_VIDEO_DATA} from '../types/CCDTypes';
import {CHECK_HAS_THOR} from '../types/index';
import {KEYS_FOR_SERVICES} from '../utils/postIMSFetchAppsData';

function useNull(e) {
	console.log(e);
	return null;
}

function getFFCProductPromise(sapCode: string, channel: string) {
	const configObject = {
		channel,
		headers: {
			withAuth: true,
			withAppId: false
		},
		config: {
			allVersion: true,
			sapCode
		},
		isCCD: true
	};

	return RestApiUtil.getFFCProductPromise(configObject);
}

export const getFFCData = (sapCode: string, productId: string, preFetchedData?: Function = () => null) => async(dispatch: Function) => {
	const ffcAppDataPromiseArray = [preFetchedData(`${KEYS_FOR_SERVICES.FFC_ALL}-${sapCode}-CCM`)
		|| getFFCProductPromise(sapCode, 'ccm').catch(useNull)];
	if (DeviceDetectionUtil.isMobileOrTab() || DeviceDetectionUtil.isNotMacOrWin()) {
		ffcAppDataPromiseArray.push(preFetchedData(KEYS_FOR_SERVICES.FFC_LATEST_FALLBACK_ALL_PLATFORM)
		|| RestApiUtil.getFFCFallbackProductPromise('latest', false));
	}
	else {
		ffcAppDataPromiseArray.push(preFetchedData(KEYS_FOR_SERVICES.FFC_ALL_FALLBACK)
			|| RestApiUtil.getFFCFallbackProductPromise('all', true));
	}
	ffcAppDataPromiseArray.push(preFetchedData(KEYS_FOR_SERVICES.FFC_FALLBACK_PRODUCT_JSON)
		|| RestApiUtil.fetchFFCFallbackProductsJson());
	return Promise.all(ffcAppDataPromiseArray).then(axios.spread((ffcResponse, fallback, fallbackProductsJson) => {
		let ffcData = ffcResponse;
		if (fallbackProductsJson) {
			appsUtil.processAndStoreFFCFallbackProducts(fallbackProductsJson);
		}
		if (!ffcData && fallback && fallbackProductsJson) {
			ffcData = fallback;
			ffcData.data = appsUtil.filterFallbackFFCData(fallback.data, sapCode);
			appsUtil.isFFCFallback = true;
			dispatch({
				type: CHECK_HAS_THOR,
				payload: {hasThor: false}
			});
		}
		dispatch({
			type: FETCH_FFC_DATA,
			payload: {sapCode, productId, ffcData}
		});
	}))
		.catch(useNull);
};

export const getVideoCardsData = (sapCode: string, locale: string) => async(dispatch: Function) => {
	let contentfulURl = `${appsUtil.getCVSDomain()}${getContentfulPath(`videoCardsInfo${sapCode}`, locale)}`;
	if (appsUtil.hasFeature('temp_contentful_to_aem_migration')) {
		contentfulURl = `${appsUtil.getAEMDomain()}${getAEMPath(`videoCardsInfo${sapCode}`, locale)}`;
	}
	else {
		contentfulURl = `${appsUtil.getCVSDomain()}${getContentfulPath(`videoCardsInfo${sapCode}`, locale)}`;
	}
	let fallbackURL = `/assets/apps/loggedOutCampaign/en/appData/${sapCode.toLowerCase()}.json`;
	if (!appsUtil.hasFeature('temp_deeplinking_loc') && locale !== 'en') {
		contentfulURl = '';
		fallbackURL = '';
	}
	const allPromisesArray = [
		axios.get(contentfulURl).catch(useNull),
		axios.get(fallbackURL).catch(useNull),
	];
	return Promise.all(allPromisesArray).then(axios.spread((videoContentfulData, videoFallbackData) => {
		dispatch({
			type: FETCH_VIDEO_DATA,
			payload: {videoContentfulData, videoFallbackData}
		});
	}));
};

export const getCompanionAppFFCData = (sapCode: string, productId: string, preFetchedData?: Function = () => null) => async(dispatch: Function) => {
	const ffcAppDataPromise = preFetchedData(`${KEYS_FOR_SERVICES.FFC_ALL}-${sapCode}-mobileApp`)
		|| getFFCProductPromise(sapCode, 'mobileApps');
	return ffcAppDataPromise.then((ffcData) => {
		dispatch({
			type: FETCH_COMPANION_FFC_DATA,
			payload: {sapCode, productId, ffcData}
		});
	}, () => {
		const ffcFallbackPromise = preFetchedData(KEYS_FOR_SERVICES.FFC_LATEST_FALLBACK_ALL_PLATFORM)
			|| RestApiUtil.getFFCFallbackProductPromise('latest', false);
		return ffcFallbackPromise.then((fallback) => {
			let ffcData = null;
			if (fallback) {
				ffcData = fallback;
				appsUtil.isFFCFallback = true;
			}
			dispatch({
				type: FETCH_COMPANION_FFC_DATA,
				payload: {sapCode, productId, ffcData}
			});
		});
	});
};

export const setErrorType = (errorType: boolean) => async(dispatch: Function) => {
	dispatch({
		type: SET_ERROR_TYPE,
		payload: {errorType}
	});
};
